import { Box, Typography } from "@mui/material";
import { HeaderStyle } from "../Common/styles/header";
import DashboardContentV2 from "./DashboardContent/DashboardContentV2";

const DashboardV2 = () => {
  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Dashboard
        </Typography>
      </Box>

      <Box sx={{ height: "calc(100% - 72px)", overflow: "auto", p: 2 }}>
        <DashboardContentV2 />
      </Box>
    </>
  );
};

export default DashboardV2;
